const CategoriesActionTypes = {
	START_LOADING_CATEGORIES: 'START_LOADING_CATEGORIES',
	UPDATE_CATEGORIES_DATA: 'UPDATE_CATEGORIES_DATA',
	UPDATE_ERROR_CATEGORIES: 'UPDATE_ERROR_CATEGORIES'
};

export default CategoriesActionTypes;
